import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'

/**
 * Returns a string in title case, where first letter of each word is capitalized
 * @example titleCase('new YORK') // 'New York'
 */
export const titleCase = (str: string | null | undefined): string => {
  if (!str) return ''
  return startCase(toLower(str))
}
